import {FormArray, FormControl, FormGroup} from '@angular/forms';

export function validateAllFormFields(formGroup: FormGroup): void {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({onlySelf: true});
      control.updateValueAndValidity();
    } else if (control instanceof FormGroup) {
      validateAllFormFields(control);
    } else if (control instanceof FormArray) {
      validateAllFormArrayFields(control as FormArray);
    }
  });
}

export function validateAllFormArrayFields(formArray: FormArray): void {
  formArray.controls.forEach(aControl => {
    if (aControl instanceof FormControl) {
      aControl.markAsTouched({onlySelf: true});
      aControl.updateValueAndValidity();
    } else if (aControl instanceof FormGroup) {
      validateAllFormFields(aControl);
    }
  });
}
